module.exports = __webpack_public_path__ + "static/Background-photo-3dab5a084fe1eb96ad0fa6487c61d658.jpg";